import { render, staticRenderFns } from "./Minimalism.vue?vue&type=template&id=397d9db9&scoped=true&"
import script from "./Minimalism.vue?vue&type=script&lang=js&"
export * from "./Minimalism.vue?vue&type=script&lang=js&"
import style0 from "./Minimalism.vue?vue&type=style&index=0&id=397d9db9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "397d9db9",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ObjectsPublicTheExportNew: require('/web/components/objects/public/TheExportNew.vue').default,TheBlockHeader: require('/web/components/TheBlockHeader.vue').default})
